//--------------------------------------------------------------------//
//******************** agentSkillsTab ********************************//
//--------------------------------------------------------------------//
// Manages the skills list for an agent. Displays skills in a table
// with name, type, and delete action. Provides create (from template
// or blank), delete with confirmation, and a full-screen IDE editor
// with publish-to-Anthropic and skill settings capabilities.
import agentSkillsTemplateUrl from './agent-skills.template.html';

angular.module('agentsTableModule')

.directive('agentSkillsTab', ['AgentSkillsService', 'GhDialog', function (AgentSkillsService, GhDialog) {
    return {
        restrict: 'E',
        scope: {
            agent: '='
        },
        controller: ['$scope', 'localizationService', function ($scope, localizationService) {
            const dictionary = localizationService.getDictionary('account_settings');
            $scope.translate = (word) => localizationService.translate(word, dictionary);

            $scope.skills = [];

            const agentId = $scope.agent._id;

            // Fetches the agent's skills from the server and updates the table.
            async function loadSkills() {
                if (!agentId) return;
                try {
                    $scope.skills = await AgentSkillsService.getSkills(agentId);
                    $scope.$applyAsync();
                } catch (err) {
                    console.error('Failed to load skills:', err);
                }
            }
            loadSkills();

            // Opens the full-screen IDE editor for a skill repo with publish and settings buttons.
            $scope.openSkillEditor = async function (agent, skill) {
                if (!skill || !skill.repo_id) return;
                var repoId = skill.repo_id;

                await gudhub.ghconstructor.getInstance('ide');

                GhDialog.show({
                    position: 'full',
                    toolbar: false,
                    template: {
                        toolbar: '',
                        content: `
                            <div class="skill-editor-ide">
                                <div class="skill-editor-ide__header">
                                    <div class="skill-editor-ide__header-left">
                                        <h2>{{agentName}} — {{skillName}}</h2>
                                        <span class="skill-settings-btn" ng-click="openSettings()" gh-icon="configuration cccccc 24px"></span>
                                        <button class="skill-publish-btn" ng-click="publishSkill()" ng-disabled="publishing">
                                            {{publishing ? 'Publishing...' : 'Publish'}}
                                        </button>
                                    </div>
                                    <span class="close_dialog" ng-click="cancel()" gh-icon="cross 0D99FF 30px"></span>
                                </div>
                                <gh-ide gh-repo-id="${repoId}"></gh-ide>
                            </div>
                        `
                    },
                    locals: {
                        agentName: agent.name,
                        dialogAgentId: agentId,
                        dialogRepoId: repoId,
                        dialogSkill: skill
                    },
                    controller: ['$scope', 'agentName', 'dialogAgentId', 'dialogRepoId', 'dialogSkill', 'AgentSkillsService', 'GhDialog', function ($scope, agentName, dialogAgentId, dialogRepoId, dialogSkill, AgentSkillsService, GhDialog) {
                        $scope.agentName = agentName;
                        $scope.skillName = dialogSkill.skill_name || dialogRepoId;
                        $scope.publishing = false;

                        // Extracts a human-readable message from nested API error JSON responses.
                        function parseErrorMessage(err) {
                            var msg = err.message || String(err);
                            try {
                                var jsonStart = msg.indexOf('{');
                                if (jsonStart !== -1) {
                                    var parsed = JSON.parse(msg.substring(jsonStart));
                                    if (parsed.error && parsed.error.message) return parsed.error.message;
                                    if (parsed.message) return parsed.message;
                                }
                            } catch (e) {}
                            return msg;
                        }

                        // Shows a success or error popup after publishing a skill's metadata.
                        function showResultPopup(success, message) {
                            GhDialog.show({
                                position: 'center',
                                class: 'agent_constructor_dialog',
                                toolbar: false,
                                template: {
                                    toolbar: '',
                                    content: `
                                        <div class="dialog_wrapper skill-publish-popup">
                                            <span gh-icon="cross 0D99FF 20px" class="skill-publish-popup__close" ng-click="cancel()"></span>
                                            <span gh-icon="${success ? 'checked 05B52C' : 'alert FF0D0D'} 65px"></span>
                                            <p class="skill-publish-popup__title">${success ? 'Skill Published' : 'Publish Failed'}</p>
                                            <p class="skill-publish-popup__message">{{message}}</p>
                                            <button class="btn ${success ? 'btn-blue' : 'btn-blue-reverse'}" ng-click="cancel()">OK</button>
                                        </div>
                                    `
                                },
                                locals: { message: message },
                                controller: ['$scope', 'message', function ($scope, message) {
                                    $scope.message = message;
                                }]
                            });
                        }

                        // Saves the skill's current name/description via the agent update endpoint.
                        $scope.publishSkill = async function () {
                            if ($scope.publishing) return;
                            $scope.publishing = true;
                            $scope.$applyAsync();

                            try {
                                await AgentSkillsService.updateSkill(dialogAgentId, dialogRepoId, {
                                    skill_name: dialogSkill.skill_name,
                                    description: dialogSkill.description
                                });
                                showResultPopup(true, 'Skill was published');
                            } catch (err) {
                                console.error('Failed to publish skill:', err);
                                showResultPopup(false, parseErrorMessage(err));
                            }
                            $scope.publishing = false;
                            $scope.$applyAsync();
                        };

                        // Opens the skill settings popup to edit name and description.
                        $scope.openSettings = function () {
                            GhDialog.show({
                                position: 'center',
                                class: 'agent_constructor_dialog',
                                toolbar: false,
                                template: {
                                    toolbar: '',
                                    content: `
                                        <div class="dialog_wrapper" style="padding: 20px; position: relative; min-width: 400px;">
                                            <span gh-icon="cross 0D99FF 20px" style="position: absolute; top: 4px; right: 4px; cursor: pointer;" ng-click="hide()"></span>
                                            <h3 style="font-size: 20px; font-weight: 500; margin-bottom: 16px; color: #333;">Skill Settings</h3>

                                            <label style="font-size: 14px; color: #666; display: block; margin-bottom: 6px;">Skill Name</label>
                                            <input type="text" ng-model="form.skill_name" ng-style="nameError && {'border-color': '#f44336'}" ng-change="nameError = false" style="width: 100%; padding: 8px; border: 1px solid #d9e2ec; border-radius: 8px; font-size: 16px; outline: none; margin-bottom: 16px;">

                                            <label style="font-size: 14px; color: #666; display: block; margin-bottom: 6px;">Description</label>
                                            <textarea ng-model="form.description" ng-style="descriptionError && {'border-color': '#f44336'}" ng-change="descriptionError = false" placeholder="What does this skill do? When should the agent use it?" style="width: 100%; padding: 8px; border: 1px solid #d9e2ec; border-radius: 8px; font-size: 14px; outline: none; margin-bottom: 16px; min-height: 80px; resize: vertical; font-family: inherit;"></textarea>

                                            <div ng-show="errMessage" style="color: #f44336; font-size: 13px; margin-bottom: 12px;">{{errMessage}}</div>
                                            <div style="display: flex; gap: 10px; justify-content: center;">
                                                <button class="btn btn-blue-reverse" style="border-style: solid; margin: 5px; padding: 8px 20px;" ng-click="hide()">Cancel</button>
                                                <button class="btn btn-blue" style="margin: 5px; padding: 8px 20px;" ng-click="save()">Save</button>
                                            </div>
                                        </div>
                                    `
                                },
                                locals: {
                                    settingsAgentId: dialogAgentId,
                                    settingsRepoId: dialogRepoId,
                                    settingsSkill: dialogSkill,
                                    ideScope: $scope
                                },
                                controller: ['$scope', 'settingsAgentId', 'settingsRepoId', 'settingsSkill', 'ideScope', 'AgentSkillsService', function ($scope, settingsAgentId, settingsRepoId, settingsSkill, ideScope, AgentSkillsService) {
                                    $scope.form = {
                                        skill_name: settingsSkill.skill_name,
                                        description: settingsSkill.description
                                    };
                                    $scope.errMessage = '';

                                    $scope.nameError = false;
                                    $scope.descriptionError = false;

                                    $scope.save = async function () {
                                        var name = ($scope.form.skill_name || '').trim();
                                        var description = ($scope.form.description || '').trim();
                                        $scope.nameError = !name;
                                        $scope.descriptionError = !description;
                                        if (!name || !description) {
                                            $scope.errMessage = 'All fields are required';
                                            return;
                                        }

                                        try {
                                            var result = await AgentSkillsService.updateSkill(settingsAgentId, settingsRepoId, {
                                                skill_name: name,
                                                description: ($scope.form.description || '').trim()
                                            });
                                            settingsSkill.skill_name = result.skill_name || name;
                                            settingsSkill.description = result.description || $scope.form.description;
                                            ideScope.skillName = settingsSkill.skill_name;
                                            ideScope.$applyAsync();
                                            $scope.hide();
                                        } catch (err) {
                                            console.error('Failed to update skill:', err);
                                            $scope.errMessage = err.message || 'Failed to update skill';
                                            $scope.$applyAsync();
                                        }
                                    };
                                }]
                            });
                        };
                    }]
                }).then(function () {
                    loadSkills();
                });
            };

            // Opens a dialog to create a new skill — from a premade template or blank with name and description.
            $scope.addCustomSkill = function (agent) {
                const skillAgentId = agent._id;
                if (!skillAgentId) return;

                GhDialog.show({
                    position: 'center',
                    class: 'agent_constructor_dialog',
                    toolbar: false,
                    template: {
                        toolbar: '',
                        content: `
                            <div class="dialog_wrapper" style="padding: 20px; position: relative; min-width: 400px;">
                                <span gh-icon="cross 0D99FF 20px" style="position: absolute; top: 4px; right: 4px; cursor: pointer;" ng-click="hide()"></span>
                                <h3 style="font-size: 20px; font-weight: 500; margin-bottom: 16px; color: #333;">Create Custom Skill</h3>

                                <label style="font-size: 14px; color: #666; display: block; margin-bottom: 6px;">Start from template (optional)</label>
                                <div style="border: 1px solid #d9e2ec; border-radius: 8px; max-height: 180px; overflow-y: auto; margin-bottom: 16px;">
                                    <div ng-click="selectTemplate(null)"
                                         style="padding: 10px 14px; cursor: pointer; font-size: 14px; border-bottom: 1px solid #eee;"
                                         ng-style="{'background': !selectedTemplate ? '#e8f4fd' : 'transparent'}">
                                        Blank (no template)
                                    </div>
                                    <div ng-repeat="tpl in templates"
                                         ng-click="selectTemplate(tpl)"
                                         style="padding: 10px 14px; cursor: pointer; font-size: 14px; text-transform: capitalize;"
                                         ng-style="{'background': selectedTemplate.id === tpl.id ? '#e8f4fd' : 'transparent', 'border-bottom': (!$last || skillRepos.length) ? '1px solid #eee' : 'none'}">
                                        {{tpl.name}}
                                    </div>
                                    <div ng-if="skillRepos.length" style="padding: 8px 14px; font-size: 12px; color: #999; text-transform: uppercase; background: #fafafa; border-bottom: 1px solid #eee;">
                                        Your Skill Repositories
                                    </div>
                                    <div ng-repeat="repo in skillRepos"
                                         ng-click="selectTemplate(repo)"
                                         style="padding: 10px 14px; cursor: pointer; font-size: 14px;"
                                         ng-style="{'background': selectedTemplate.id === repo.id ? '#e8f4fd' : 'transparent', 'border-bottom': $last ? 'none' : '1px solid #eee'}">
                                        {{repo.name}}
                                    </div>
                                </div>

                                <label style="font-size: 14px; color: #666; display: block; margin-bottom: 6px;">Skill Name</label>
                                <input type="text" ng-model="skillName" ng-style="nameError && {'border-color': '#f44336'}" ng-change="nameError = false" placeholder="e.g. data-analysis" style="width: 100%; padding: 8px; border: 1px solid #d9e2ec; border-radius: 8px; font-size: 16px; outline: none; margin-bottom: 16px;">

                                <label style="font-size: 14px; color: #666; display: block; margin-bottom: 6px;">Description</label>
                                <textarea ng-model="skillDescription" ng-style="descriptionError && {'border-color': '#f44336'}" ng-change="descriptionError = false" placeholder="What does this skill do? When should the agent use it?" style="width: 100%; padding: 8px; border: 1px solid #d9e2ec; border-radius: 8px; font-size: 14px; outline: none; margin-bottom: 16px; min-height: 80px; resize: vertical; font-family: inherit;"></textarea>

                                <button class="btn save_btn btn-grean" ng-click="create()">Create</button>
                            </div>
                        `
                    },
                    // existingRepoIds excludes repos already attached to this agent from the
                    // "attach existing repo" list below, since re-attaching one would create
                    // a duplicate skill_repos entry server-side.
                    locals: { skillAgentId: skillAgentId, existingRepoIds: $scope.skills.map(function (s) { return s.repo_id; }) },
                    controller: ['$scope', 'skillAgentId', 'existingRepoIds', 'AgentSkillsService', function ($scope, skillAgentId, existingRepoIds, AgentSkillsService) {
                        $scope.skillName = '';
                        $scope.skillDescription = '';
                        $scope.templates = [];
                        $scope.skillRepos = [];
                        $scope.selectedTemplate = null;

                        AgentSkillsService.getPremadeSkills().then(function (list) {
                            $scope.templates = list || [];
                            $scope.$applyAsync();
                        });

                        // Fetches the user's own "skills"-type repos so they can be
                        // attached to the agent directly, alongside premade templates.
                        AgentSkillsService.getSkillRepos().then(function (repos) {
                            $scope.skillRepos = (repos || [])
                                .filter(function (repo) { return existingRepoIds.indexOf(repo._id) === -1; })
                                .map(function (repo) {
                                    return { id: repo._id, name: repo.repo_name, description: repo.description, kind: 'repo' };
                                });
                            $scope.$applyAsync();
                        }).catch(function (err) {
                            console.error('Failed to load skill repos:', err);
                        });

                        // Derives a short description from a template's content: the text before
                        // the first markdown heading, trimmed to a word boundary.
                        function extractDescriptionFromContent(content) {
                            if (!content) return '';
                            var headingIdx = content.search(/\n#{1,6}\s/);
                            var text = (headingIdx !== -1 ? content.slice(0, headingIdx) : content).trim();
                            var maxLen = 300;
                            if (text.length > maxLen) {
                                text = text.slice(0, maxLen).replace(/\s+\S*$/, '') + '...';
                            }
                            return text;
                        }

                        var autoFilledName = '';
                        var autoFilledDescription = '';

                        $scope.selectTemplate = function (tpl) {
                            $scope.selectedTemplate = tpl;

                            var derivedName = '';
                            var derivedDescription = '';
                            if (tpl) {
                                derivedName = tpl.kind === 'repo' ? tpl.name : tpl.id;
                                derivedDescription = tpl.kind === 'repo' ? (tpl.description || '') : extractDescriptionFromContent(tpl.content);
                            }

                            // Only overwrite if the field still holds what we last auto-filled
                            // (or is empty) — preserves any text the user typed by hand.
                            if ($scope.skillName === autoFilledName) {
                                $scope.skillName = derivedName;
                            }
                            if ($scope.skillDescription === autoFilledDescription) {
                                $scope.skillDescription = derivedDescription;
                            }
                            autoFilledName = derivedName;
                            autoFilledDescription = derivedDescription;
                        };

                        $scope.nameError = false;
                        $scope.descriptionError = false;

                        $scope.create = async function () {
                            try {
                                var name = ($scope.skillName || '').trim();
                                var description = ($scope.skillDescription || '').trim();
                                $scope.nameError = !name;
                                $scope.descriptionError = !description;
                                if (!name || !description) return;
                                if ($scope.selectedTemplate && $scope.selectedTemplate.kind === 'repo') {
                                    // Existing repo: pass repo_id so the server attaches it directly
                                    // instead of creating a new repo (as premade_skill/blank do).
                                    await AgentSkillsService.addSkill(skillAgentId, { repo_id: $scope.selectedTemplate.id, name: name, description: description });
                                } else if ($scope.selectedTemplate) {
                                    await AgentSkillsService.addSkill(skillAgentId, { premade_skill: $scope.selectedTemplate.id, name: name, description: description });
                                } else {
                                    await AgentSkillsService.addSkill(skillAgentId, { name: name, description: description });
                                }
                                $scope.hide();
                            } catch (err) {
                                console.error('Failed to create skill:', err);
                            }
                        };
                    }]
                }).then(function () {
                    loadSkills();
                });
            };

            // Shows a confirmation dialog and deletes the skill from the agent on confirm.
            $scope.deleteSkill = function (skill) {
                if (!agentId || !skill.repo_id) return;

                GhDialog.show({
                    position: 'center',
                    class: 'agent_constructor_dialog',
                    toolbar: false,
                    template: {
                        toolbar: '',
                        content: `
                            <div class="dialog_wrapper" style="padding: 20px; position: relative; min-width: 360px; text-align: center;">
                                <span gh-icon="cross 0D99FF 20px" style="position: absolute; top: 4px; right: 4px; cursor: pointer;" ng-click="hide()"></span>
                                <h3 style="font-size: 18px; font-weight: 500; margin-bottom: 12px; color: #333;">Delete Skill</h3>
                                <p style="font-size: 14px; color: #666; margin-bottom: 20px;">Are you sure you want to delete <strong>{{skillName}}</strong>?</p>
                                <div style="display: flex; gap: 10px; justify-content: center;">
                                    <button class="btn btn-blue-reverse" ng-click="hide()">Cancel</button>
                                    <button class="btn save_btn btn-red" ng-click="confirm()">Delete</button>
                                </div>
                            </div>
                        `
                    },
                    locals: { skillName: skill.skill_name || skill.repo_id },
                    controller: ['$scope', 'skillName', function ($dialogScope, skillName) {
                        $dialogScope.skillName = skillName;
                        $dialogScope.confirm = async function () {
                            try {
                                await AgentSkillsService.removeSkill(agentId, skill.repo_id);
                                $dialogScope.hide();
                                loadSkills();
                            } catch (err) {
                                console.error('Failed to remove skill:', err);
                                $dialogScope.hide();
                                var msg = err.message || String(err);
                                try {
                                    var jsonStart = msg.indexOf('{');
                                    if (jsonStart !== -1) {
                                        var parsed = JSON.parse(msg.substring(jsonStart));
                                        if (parsed.error && parsed.error.message) msg = parsed.error.message;
                                        else if (parsed.message) msg = parsed.message;
                                    }
                                } catch (e) {}
                                GhDialog.show({
                                    position: 'center',
                                    class: 'agent_constructor_dialog',
                                    toolbar: false,
                                    template: {
                                        toolbar: '',
                                        content: `
                                            <div class="dialog_wrapper skill-publish-popup">
                                                <span gh-icon="cross 0D99FF 20px" class="skill-publish-popup__close" ng-click="cancel()"></span>
                                                <span gh-icon="alert FF0D0D 65px"></span>
                                                <p class="skill-publish-popup__title">Delete Failed</p>
                                                <p class="skill-publish-popup__message">{{message}}</p>
                                                <button class="btn btn-blue-reverse" style="border-style: solid;" ng-click="cancel()">OK</button>
                                            </div>
                                        `
                                    },
                                    locals: { message: msg },
                                    controller: ['$scope', 'message', function ($scope, message) {
                                        $scope.message = message;
                                    }]
                                });
                            }
                        };
                    }]
                });
            };
        }],
        templateUrl: agentSkillsTemplateUrl
    };
}]);
